/* __next_internal_client_entry_do_not_use__ Route auto */ import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { Route as ReactRoute, useLocation } from "react-router-dom";
import { removeLocaleFromUrl } from "./util";
export var Route = function(props) {
    var currentLocation = useLocation();
    var overriddenLocation = props.location;
    var augmentedLocation = React.useMemo(function() {
        var newLocation = _object_spread({}, currentLocation, overriddenLocation);
        newLocation.pathname = removeLocaleFromUrl(newLocation.pathname);
        return newLocation;
    }, [
        currentLocation,
        overriddenLocation
    ]);
    var augmentedPath = React.useMemo(function() {
        return props.path ? removeLocaleFromUrl("".concat(props.path)) : "";
    }, [
        props.path
    ]);
    if (!augmentedPath) {
        return /*#__PURE__*/ _jsx(ReactRoute, _object_spread_props(_object_spread({}, props), {
            location: augmentedLocation
        }));
    }
    return /*#__PURE__*/ _jsx(ReactRoute, _object_spread_props(_object_spread({}, props), {
        path: augmentedPath,
        location: augmentedLocation
    }));
};
